import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../Components/InnerLayout/Headerbar";
const Inventories = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
              <div className="container px-0">
                <div className="top-header-sec mb-3">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Inventory List
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-6 col-10">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>

                      <div className="col-md-4 col-2 align-right">
                        <div className="field text-right">
                          <button
                            id="download"
                            className="btn green-btn-revert download-icon mr0"
                            onclick="downloadAccounts();"
                          >
                            <i className="i-icon"> </i> Download
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine2"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine2"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine2"
                      >
                        <div className="col d-flex align-items-center justify-content-between flex-wrap">
                          <h4 className="event-alert p-0 mb-0">Ingredients</h4>
                          <h5 className="bal-h5">
                            # Of Items: 905Total Value: $3,472.29{" "}
                          </h5>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseNine2"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingNine2"
                    >
                      <div className="">
                        <div className="row mx-0">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive">
                                <table className="checklist-table remove-space ingredTable">
                                  <thead>
                                    <tr>
                                      <th>Category</th>
                                      <th>Ingredient Name</th>
                                      <th className="text-right">
                                        Current Unit Price
                                      </th>
                                      <th className="text-right">
                                        MTD Units Purchased
                                      </th>
                                      <th className="text-right">
                                        MTD Purchase Amount
                                      </th>
                                      <th className="text-right">
                                        Current Stock
                                      </th>
                                      <th className="text-right">
                                        Current Value
                                      </th>
                                      <th className="action-td">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Beer</td>
                                      <td>Kronenbourg Blanc</td>
                                      <td className="align-right">
                                        <span>$0.000&nbsp; per ml</span>

                                        <span>$0.000&nbsp; per ml</span>

                                        <span>$0.000&nbsp; per ml</span>
                                      </td>
                                      <td className="align-right">
                                        <span>0 </span>
                                        <span>0 </span>
                                        <span>0 </span>
                                      </td>
                                      <td className="align-right">
                                        <span>$0.00 </span>
                                        <span>$0.00 </span>
                                        <span>$0.00 </span>
                                      </td>
                                      <td className="align-right">
                                        <span>0.000 </span>
                                        <span>0.000 </span>
                                        <span>0.000 </span>
                                      </td>
                                      <td className="align-right">
                                        <span>$0.000 </span>
                                        <span>$0.000 </span>
                                        <span>$0.000 </span>
                                      </td>
                                      <td className="action-td">
                                        <a class="circle_icon">
                                          <i class="iconSprites edit-icon">
                                            <div class="tooltip-sm"> Edit </div>
                                          </i>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div class="my-3">
                                <button
                                  class="btn green-btn-revert add-plus addSp"
                                  id="addCount"
                                  type="button"
                                >
                                  <i class="i-icon"> </i> Add Ingredients
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine3"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine3"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine3"
                      >
                        <div className="col d-flex align-items-center justify-content-between flex-wrap">
                          <h4 className="event-alert p-0 mb-0">Recipes</h4>
                          <h5 className="bal-h5"># Of Items: 58</h5>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseNine3"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingNine3"
                    >
                      <div className="">
                        <div className="row mx-0">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive">
                                <table className="checklist-table remove-space ingredTable">
                                  <thead>
                                    <tr>
                                      <th>Category</th>
                                      <th>Recipe Name</th>
                                      <th className="text-right">
                                        Serving Amount
                                      </th>
                                      <th className="action-td">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Food</td>
                                      <td>Aioli Sauce</td>
                                      <td className="align-right">
                                        $0.04 per Serving{" "}
                                      </td>
                                      <td className="action-td">
                                        <a class="circle_icon">
                                          <i class="iconSprites edit-icon">
                                            <div class="tooltip-sm"> Edit </div>
                                          </i>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="my-3">
                                <button
                                  class="btn green-btn-revert add-plus addSp"
                                  id="addCount"
                                  type="button"
                                >
                                  <i class="i-icon"> </i> Add Recipes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine4"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine4"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine4"
                      >
                        <div className="col d-flex align-items-center justify-content-between flex-wrap">
                          <h4 className="event-alert p-0 mb-0">Menu Items</h4>
                          <h5 className="bal-h5"># Of Items: 528</h5>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseNine4"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingNine4"
                    >
                      <div className="">
                        <div className="row mx-0">
                          <div className="container px-0">
                            <div className="shadowclass mt-0">
                              <div className="table-responsive">
                                <table className="checklist-table remove-space ingredTable">
                                  <thead>
                                    <tr>
                                      <th>Category</th>
                                      <th>Menu Item Name</th>
                                      <th className="text-right">
                                        Menu Item Cost
                                      </th>
                                      <th className="action-td">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Beers</td>
                                      <td>Harry's Premium Lager Half Pint</td>
                                      <td>$3.00</td>
                                      <td className="action-td">
                                        <a class="circle_icon">
                                          <i class="iconSprites edit-icon">
                                            <div class="tooltip-sm"> Edit </div>
                                          </i>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="my-3">
                                <button
                                  class="btn green-btn-revert add-plus addSp"
                                  id="addCount"
                                  type="button"
                                >
                                  <i class="i-icon"> </i> Add Menu Items
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Inventories;
